(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    

  const url = new URL(window.location.href);

  if (url.hash) {

    document.addEventListener('DOMContentLoaded', () => {

      const card = document.getElementById(url.hash.slice(1));

      if (card) card.scrollIntoView({ behavior: 'instant' });

    }, { once: true });

  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-scroll"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nano-product-slider')) {
  customElements.define('nano-product-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') {
        this.setupScrollReveal();
        this.updateControls();
        return;
      }
      this.dataset.initialized = 'true';
      this.track = this.querySelector('[data-slider-track]');
      this.cards = Array.from(this.querySelectorAll('[data-product-card]'));
      this.filters = Array.from(this.querySelectorAll('[data-filter]'));
      this.prev = this.querySelector('[data-slider-prev]');
      this.next = this.querySelector('[data-slider-next]');
      this.progress = this.querySelector('[data-progress]');
      this.thumb = this.querySelector('[data-progress-thumb]');
      this.emptyGroup = this.querySelector('[data-empty-group]');
      this.controls = this.querySelector('[data-slider-controls]');
      if (!this.track || !this.filters.length) return;
      this.filters.forEach(button => button.addEventListener('click', () => this.applyFilter(button.dataset.filter)));
      this.prev?.addEventListener('click', () => this.move(-1));
      this.next?.addEventListener('click', () => this.move(1));
      this.track.addEventListener('scroll', () => this.updateControls(), { passive: true });
      this.progress?.addEventListener('click', event => this.seek(event));
      this.setupDragging();
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.updateControls());
        this.resizeObserver.observe(this.track);
      } else {
        window.addEventListener('resize', () => this.updateControls());
      }
      this.applyFilter(this.dataset.defaultFilter || 'featured');
      this.setupScrollReveal();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.revealObserver?.disconnect();
    }

    visibleCards() { return this.cards.filter(card => !card.hidden); }

    applyFilter(filter) {
      this.cards.forEach(card => { card.hidden = card.dataset.tab !== filter; });
      const count = this.visibleCards().length;
      this.filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === filter)));
      if (this.emptyGroup) this.emptyGroup.hidden = count > 0;
      if (this.controls) this.controls.hidden = count === 0;
      this.track.scrollLeft = 0;
      this.updateControls();
      this.observePendingCards();
    }

    move(direction) {
      const card = this.visibleCards()[0];
      if (!card) return;
      const styles = getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
    }

    seek(event) {
      if (!this.progress) return;
      const rect = this.progress.getBoundingClientRect();
      const ratio = Math.min(1, Math.max(0, (event.clientX - rect.left) / rect.width));
      const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      this.track.scrollTo({ left: maxScroll * ratio, behavior: 'smooth' });
    }

    updateControls() {
      if (!this.track || !this.progress || !this.thumb) return;
      const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const ratio = maxScroll ? this.track.scrollLeft / maxScroll : 0;
      const visibleRatio = this.track.scrollWidth ? Math.min(1, this.track.clientWidth / this.track.scrollWidth) : 1;
      const progressWidth = this.progress.clientWidth;
      const thumbWidth = Math.min(progressWidth, Math.max(36, progressWidth * visibleRatio));
      this.thumb.style.width = `${thumbWidth}px`;
      this.thumb.style.transform = `translateX(${Math.max(0, progressWidth - thumbWidth) * ratio}px)`;
      if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
      if (this.next) this.next.disabled = this.track.scrollLeft >= maxScroll - 2 || maxScroll === 0;
    }

    setupDragging() {
      let pressed = false, startX = 0, startScroll = 0, moved = false, blockNextClick = false;
      this.track.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        // Essential: don't capture pointer events on links: pointer capture can stop navigation.
        if (event.target.closest('a, button')) return;
        pressed = true;
        startX = event.clientX;
        startScroll = this.track.scrollLeft;
        moved = false;
      });
      this.track.addEventListener('pointermove', event => {
        if (!pressed) return;
        const delta = event.clientX - startX;
        if (Math.abs(delta) > 8) {
          moved = true;
          this.track.classList.add('is-dragging');
          this.track.scrollLeft = startScroll - delta;
        }
      });
      const release = () => {
        if (moved) blockNextClick = true;
        pressed = false;
        moved = false;
        this.track.classList.remove('is-dragging');
      };
      this.track.addEventListener('pointerup', release);
      this.track.addEventListener('pointercancel', () => { blockNextClick = false; release(); });
      this.track.addEventListener('click', event => {
        if (!blockNextClick) return;
        event.preventDefault();
        event.stopPropagation();
        blockNextClick = false;
      }, true);
      this.track.addEventListener('pointerdown', event => {
        if (event.target.closest('a')) blockNextClick = false;
      }, true);
    }

    setupScrollReveal() {
      this.revealObserver?.disconnect();
      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const heading = this.querySelector('.np-slider__heading');
      if (heading && !heading.dataset.npWordsPrepared) {
        heading.dataset.npWordsPrepared = 'true';
        const fragment = document.createDocumentFragment();
        let index = 0;
        heading.textContent.split(/(\s+)/).forEach(part => {
          if (!part) return;
          if (/^\s+$/.test(part)) { fragment.appendChild(document.createTextNode(part)); return; }
          const mask = document.createElement('span');
          mask.className = 'np-slider__word-mask';
          const word = document.createElement('span');
          word.className = 'np-slider__word';
          word.textContent = part;
          word.style.setProperty('--np-word-delay', `${Math.min(index++ * 55, 450)}ms`);
          mask.appendChild(word);
          fragment.appendChild(mask);
        });
        heading.replaceChildren(fragment);
      }
      const filters = this.querySelector('.np-slider__filters');
      if (filters) filters.style.setProperty('--np-reveal-delay', '140ms');
      if (this.controls) this.controls.style.setProperty('--np-reveal-delay', '100ms');
      this.cards.forEach((card, index) => card.style.setProperty('--np-reveal-delay', `${Math.min((index % 12) * 65, 380)}ms`));
      this.revealObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting || entry.target.hidden) return;
          entry.target.classList.add('np-slider__is-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });
      this.classList.add('np-slider--motion-ready');
      if (heading) this.revealObserver.observe(heading);
      if (filters) this.revealObserver.observe(filters);
      if (this.controls && !this.controls.hidden) this.revealObserver.observe(this.controls);
      this.observePendingCards();
    }

    observePendingCards() {
      if (!this.revealObserver) return;
      this.visibleCards().forEach(card => {
        if (!card.classList.contains('np-slider__is-visible')) this.revealObserver.observe(card);
      });
      if (this.controls && !this.controls.hidden && !this.controls.classList.contains('np-slider__is-visible')) this.revealObserver.observe(this.controls);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('np-scroll-cards')) {
    customElements.define('np-scroll-cards', class extends HTMLElement {
      connectedCallback() {
        // Defer until the browser has parsed all child cards, including editor reloads.
        this.initFrame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        if (!this.isConnected || this.abort) return;
        this.abort = new AbortController();
        this.cards = Array.from(this.querySelectorAll('.nps-card'));
        this.track = this.querySelector('.nps-track');
        this.stage = this.querySelector('.nps-stage');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        // Prepare entrance animations without disturbing the existing sticky-card motion.
        this.setupContentReveals();
        this.queue = () => {
          if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.draw(); });
        };
        this.resize = () => {
          cancelAnimationFrame(this.measureFrame);
          this.measureFrame = requestAnimationFrame(() => this.measure());
        };
        const opts = { signal: this.abort.signal };
        // Element scroll events do not bubble to window. Capture them on document
        // so themes using .page-wrapper (overflow:auto) update the cards too.
        document.addEventListener('scroll', this.queue, { ...opts, passive: true, capture: true });
        window.addEventListener('scroll', this.queue, { ...opts, passive: true });
        window.addEventListener('resize', this.resize, opts);
        this.motion.addEventListener('change', this.resize, opts);
        this.addEventListener('shopify:block:select', e => {
          if (!this.pinned) return;
          const index = this.cards.findIndex(card => card.dataset.cardId === e.detail.blockId);
          if (index < 0) return;
          this.forced = index;
          this.draw();
          const current = this.scrollRoot ? this.scrollRoot.scrollTop : window.scrollY;
          const top = current + this.track.getBoundingClientRect().top - this.viewportTop() + index * this.distance;
          (this.scrollRoot || window).scrollTo({ top, behavior: 'instant' });
        }, opts);
        this.addEventListener('shopify:block:deselect', () => {
          this.forced = null;
          this.queue();
        }, opts);
        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(this.resize);
          this.observer.observe(this.track);
          this.querySelectorAll('.nps-copy').forEach(el => this.observer.observe(el));
        }
        if (document.fonts) document.fonts.ready.then(() => { if (this.isConnected) this.resize(); });
        this.resize();
      }
      setupContentReveals() {
        if (!('IntersectionObserver' in window) || this.motion.matches) return;
        this.cards.forEach(card => {
          const title = card.querySelector('.nps-title');
          if (title && !title.dataset.npsWordsReady) {
            title.dataset.npsWordsReady = 'true';
            const nodes = [];
            const walker = document.createTreeWalker(title, NodeFilter.SHOW_TEXT);
            while (walker.nextNode()) nodes.push(walker.currentNode);
            let wordIndex = 0;
            nodes.forEach(node => {
              if (!node.textContent.trim()) return;
              const parts = node.textContent.split(/(\s+)/);
              const fragment = document.createDocumentFragment();
              parts.forEach(part => {
                if (!part) return;
                if (/^\s+$/.test(part)) {
                  fragment.appendChild(document.createTextNode(part));
                  return;
                }
                const mask = document.createElement('span');
                mask.className = 'nps-word-mask';
                const word = document.createElement('span');
                word.className = 'nps-word';
                word.textContent = part;
                word.style.setProperty('--nps-word-delay', Math.min(wordIndex * 55, 850) + 'ms');
                mask.appendChild(word);
                fragment.appendChild(mask);
                wordIndex++;
              });
              node.replaceWith(fragment);
            });
          }
          const description = card.querySelector('.nps-description');
          if (description) description.style.setProperty('--nps-reveal-delay', '180ms');
          card.querySelectorAll('.nps-benefit').forEach((benefit, index) => {
            benefit.style.setProperty('--nps-reveal-delay', (240 + index * 105) + 'ms');
          });
          const image = card.querySelector('.nps-media');
          if (image) image.style.setProperty('--nps-reveal-delay', '180ms');
        });
        this.classList.add('nps-motion-ready');
      }
      refreshContentObserver(enabled) {
        if (!('IntersectionObserver' in window) || this.motion.matches) {
          this.revealObserver?.disconnect();
          this.revealObserver = null;
          this.classList.remove('nps-motion-ready');
          return;
        }
        this.setupContentReveals();
        // A mode change (pinned desktop / stacked mobile) needs a fresh set of targets.
        if (this.revealObserver && this.revealPinned === enabled) return;
        this.revealObserver?.disconnect();
        this.revealPinned = enabled;
        this.revealObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            if (this.pinned) {
              if (entry.target === this.stage) {
                this.revealSectionEntered = true;
                this.draw();
                observer.unobserve(this.stage);
              }
            } else if (entry.target.classList.contains('nps-card')) {
              this.revealCard(entry.target);
              observer.unobserve(entry.target);
            }
          });
        }, { threshold:0.08, rootMargin:'0px 0px -6% 0px' });
        if (enabled) {
          if (!this.revealSectionEntered) this.revealObserver.observe(this.stage);
        } else {
          this.cards.forEach(card => {
            if (!card.classList.contains('nps-card--revealed')) this.revealObserver.observe(card);
          });
        }
      }
      revealCard(card) {
        if (card && !card.classList.contains('nps-card--revealed')) {
          card.classList.add('nps-card--revealed');
        }
      }
      findScrollRoot() {
        // Match the containing scrollport used by CSS position:sticky.
        for (let node = this.parentElement; node && node !== document.body && node !== document.documentElement; node = node.parentElement) {
          if (/(auto|scroll|overlay|hidden)/.test(getComputedStyle(node).overflowY)) return node;
        }
        return null;
      }
      viewportTop() {
        return this.top + (this.scrollRoot ? this.scrollRoot.getBoundingClientRect().top + this.scrollRoot.clientTop : 0);
      }
      measure() {
        if (!this.isConnected) return;
        const root = this.findScrollRoot();
        if (root !== this.scrollRoot) {
          if (this.scrollRoot) this.observer?.unobserve(this.scrollRoot);
          this.scrollRoot = root;
          if (root) this.observer?.observe(root);
        }
        const minimumTop = Number(this.dataset.offset) || 0;
        this.distance = Number(this.dataset.distance) || 700;
        const contentHeight = Math.max(0, ...this.cards.map(c => c.querySelector('.nps-copy').scrollHeight));
        const viewportHeight = this.scrollRoot ? this.scrollRoot.clientHeight : window.innerHeight;
        const available = viewportHeight - minimumTop - 40;
        this.height = Math.min(Math.max(Number(this.dataset.height) || 620, contentHeight), available);
        // Center the whole stack, while respecting space reserved for a fixed menu.
        this.top = Math.max(minimumTop, (viewportHeight - this.height - 24) / 2);
        const enabled = this.dataset.animate === 'true' && this.cards.length > 1 &&
          window.innerWidth >= 990 && !this.motion.matches && this.height >= 400 &&
          contentHeight <= this.height;
        this.pinned = enabled;
        this.toggleAttribute('data-pinned', enabled);
        if (enabled) {
          this.style.setProperty('--nps-card-height', this.height + 'px');
          this.style.setProperty('--nps-stage-height', (this.height + 24) + 'px');
          this.style.setProperty('--nps-top', this.top + 'px');
          this.style.setProperty('--nps-track-height', (this.height + 24 + (this.cards.length - 1) * this.distance) + 'px');
        } else {
          this.cards.forEach(c => {
            c.style.transform = ''; c.style.visibility = ''; c.style.zIndex = '';
            c.removeAttribute('aria-hidden'); c.inert = false;
          });
        }
        this.refreshContentObserver(enabled);
        this.draw();
      }
      draw() {
        if (!this.pinned) return;
        const progress = this.forced != null ? this.forced : Math.max(0, Math.min(
          this.cards.length - 1, (this.viewportTop() - this.track.getBoundingClientRect().top) / this.distance
        ));
        const active = Math.min(Math.floor(progress), this.cards.length - 1);
        const fraction = progress - active;
        // Reveal incoming pinned card while it slides in, not during initial page load.
        if (this.revealSectionEntered) {
          this.revealCard(this.cards[active]);
          if (fraction > 0.06) this.revealCard(this.cards[active + 1]);
        }
        this.cards.forEach((card, index) => {
          const outgoing = index === active && active < this.cards.length - 1;
          const future = index > active;
          const visible = index === active || index === active + 1;
          let y = 24, scale = 1;
          if (outgoing) y -= fraction * (this.height + 60);
          if (future) { y = index === active + 1 ? fraction * 24 : 0; }
          card.style.transform = 'translate3d(0,' + y + 'px,0) scale(' + scale + ')';
          card.style.zIndex = String(this.cards.length - index);
          card.style.visibility = visible ? 'visible' : 'hidden';
          // Only the foreground card participates in accessibility navigation.
          card.setAttribute('aria-hidden', String(index !== active));
          card.inert = index !== active;
        });
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.abort = null;
        this.observer?.disconnect();
        this.revealObserver?.disconnect();
        this.revealObserver = null;
        cancelAnimationFrame(this.initFrame);
        cancelAnimationFrame(this.frame);
        this.frame = 0;
        cancelAnimationFrame(this.measureFrame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
